import styled from "styled-components";

export const Section = styled.div`
  padding: 10px;
  /*overflow-y: auto;*/
`;
